import { useMemo } from "react";
import { useUserCircle } from "./useUserCircle";
import { getClosestMeetingToCurrentTime } from "@platform/utils/getClosestMeetingToCurrentTime";

export function useCurrentMeeting() {
  const circle = useUserCircle({ isWithStandaloneMeetings: true });

  const meetings = circle?.meetings;

  // Find the closest meeting to the current time
  const currentMeeting = useMemo(() => {
    if (!meetings) return null;
    if (meetings.length === 0) return null;

    return getClosestMeetingToCurrentTime({ meetings });
  }, [meetings]);

  return {
    currentMeeting,
  };
}

export default useCurrentMeeting;
